import Rest from './Rest';
import TokenService from './Token.service';

export class AdminService {

  static async getAdminList(pagination) {
    return Rest.post(`/admin-listing`, pagination)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching admin list:', error);
        throw error;
      });
  }
  // static async getUserDetails(userId) {
  //   return Rest.post(`/user`, { id: userId }
  //   )
  //     .then(response => {
  //       return response.data;
  //     })
  //     .catch(error => {
  //       console.error('Error fetching user details:', error);
  //       throw error;
  //     });
  // }
  static async getAdminMenuList() {
    return Rest.get(`/admin-menu`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching admin menu list:', error);
        throw error;
      });
  }

  static async getUserDetails(userId) {
    return Rest.post(`/user/view`, { user_id: userId })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching user details:', error);
        throw error;
      });
  }
  static async updateUserDetails(userDetails) {
    return Rest.post(`/user/update`, userDetails)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error updating user details:', error);
        throw error;
      });
  }
  static async manageUserPermissions(userId, menuAccess) {
    return Rest.post(`/user/manage-permissions`, { user_id: userId, menu_access: menuAccess })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error updating user permissions:', error);
        throw error;
      });
  }

  static async addAdminUser(userData) {
    return Rest.post(`/user/add`, userData, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error adding admin user:', error.response?.data || error.message);
        throw error;
      });
  }


  static async changeUserStatus(userId, status) {
    return Rest.post(`/user/change-status`, { user_id: userId, status: status })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error changing user status:', error.response?.data || error.message);
        throw error;
      });
  }

  static async deleteAdminUser(userId) {
    return Rest.post(`/user/delete`, { user_id: userId })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error deleting admin user:', error.response?.data || error.message);
        throw error;
      });
  }
  static async deleteRequestorUser(payload) {
    return Rest.post(`/user/delete-requestor`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error deleting admin user:', error.response?.data || error.message);
        throw error;
      });
  }

  
  static async deleteAppointmentDurationCompensationDetailsWRTLab(lab_id) {
    return Rest.post(`/delete-appointment-compensation`, { lab_id: lab_id })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error deleting appointment duration and compensation detils:', error.response?.data || error.message);
        throw error;
      });
  }
  
  static async getEmailTempletList(pagination) {
    return Rest.post(`/email-template-list`, pagination)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching email template list:', error);
        throw error;
      });
  }

  
  static async getEmailTempletOptions() {
    return Rest.get(`/email-options`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching email template options:', error);
        throw error;
      });
  }


//api endpoint doesnt exists as of now since we dont have add email template functionality 
  static async addEmailTempletList(emailTemplateData) {
    return Rest.post(`/add-template-list`, emailTemplateData)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error adding email template:', error);
        throw error;
      });
  }

  static async updateEmailTempletList(emailTemplateData) {
    return Rest.post(`/update-email-template`, emailTemplateData)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error updating email template:', error);
        throw error;
      });
  }


  static async changeEmailTemplateEmailStatus(userId, status) {
    return Rest.post(`/change-email-status`, { template_id: userId, status: status })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error changing email template status:', error.response?.data || error.message);
        throw error;
      });
  }

  
  static async deleteEmailTemplate(userId) {
    return Rest.post(`/delete-email-template`, { template_id: userId })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error deleting email template', error.response?.data || error.message);
        throw error;
      });
  }

  static async getDonorPaymentMethodList(userId) {
    return Rest.post(`/user/donor-payment-method-list`, { user_id: userId })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting donors payment methods list', error.response?.data || error.message);
        throw error;
      });
  }
  
  static async verifyUserPaymentMethod(userId, paymentMethodId, amount) {
    return Rest.post(`/user/payment-method-verify`, {
        user_id: userId,
        payment_method_id: paymentMethodId,
        amount: amount
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(
          'Error verifying payment method',
          error.response?.data || error.message
        );
        throw error;
      });
  }

  static async markPaymentCompleted(payload) {
    return Rest.post(`/mark-payment-completed`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error(
          "Error updating payment status:",
          error.response?.data || error.message
        );
        throw error;
      });
  }
  
  static async getRequests() {
    try {
      const response = [
        {
          status: 'Open',
          jobNumber: 'S3-SH001',
          sampleType: ['Blood', 'Bodily Fluid'],
          dueDate: '12/12/22',
          requestor: 'Marley Rosser',
          projectName: 'Project 1',
          donors: '0/10',
        },
        {
          status: 'Partially Booked',
          jobNumber: 'S3-SH002',
          sampleType: ['Bodily Fluid'],
          dueDate: '12/13/22',
          requestor: 'Marley Rosser',
          projectName: 'Project for Health Study',
          donors: '1/10',
        },
        {
          status: 'Fully Booked',
          jobNumber: 'S3-SH003',
          sampleType: ['Bodily Fluid'],
          dueDate: '12/13/22',
          requestor: 'Marley Rosser',
          projectName: 'Project for Health Study',
          donors: '1/10',
        },
        {
          status: 'Collected',
          jobNumber: 'S3-SH004',
          sampleType: ['Buccal Swab'],
          dueDate: '12/14/22',
          requestor: 'Paityn Baptista',
          projectName: 'Clinical Research for Infectious Diseases',
          donors: '3/10',
        },
        {
          status: 'Picked Up',
          jobNumber: 'S3-SH005',
          sampleType: ['Hair Follicle'],
          dueDate: '12/15/22',
          requestor: 'Cheyenne Carder',
          projectName: 'Study on Hair Growth Patterns',
          donors: '0/5',
        },
        {
          status: 'Canceled',
          jobNumber: 'S3-SH006',
          sampleType: ['Skin Tape'],
          dueDate: '12/16/22',
          requestor: 'Jackson Owens',
          projectName: 'Skin Adhesive Study',
          donors: '5/10',
        }
      ];
      return response;
    } catch (error) {
      console.error('Error fetching requests:', error);
      return [];
    }
  }

  static async getRequestorListTrainingStatusTypes() {
    return [
      { id: 'Yes', label: 'Yes', value: 1 },
      { id: 'No', label: 'No', value: 0 },
    ];
  }

  static async getAdminListStatusTypes() {
    return [
      { id: 'Active', label: 'Active', value: true },
      { id: 'Inactive', label: 'Inactive', value: false },
    ];
  }
  static async getEmailTemplateFromAdminList() {
    return [
      { id: '1', label: 'Admin 1' },
      { id: '2', label: 'Admin 2' },
    ];
  }

  static async getEmailTemplateBCCList() {
    return [
      { id: '1', label: 'BCC 1' },
      { id: '2', label: 'BCC 2' },
    ];
  }


  static async getAdminListGenderTypes() {
    return [
      { id: 'XY', label: 'Male (XY)', value: 'XY' },
      { id: 'XX', label: 'Female (XX)', value: 'XX' },
    ];
  }

  
  static async getAdminListPaymentsTypes() {
    // return Rest.post(`/user/donor-payment-method-list`, {user_id: TokenService.getUserId()}).then((response)=>{
    //   debugger
    //   console.log(response.data);
    //   return response.data;
    // }).catch((error)=>{
    //     console.error(
    //       'Error verifying payment method',
    //       error.response?.data || error.message
    //     );
    //     throw error;
    // });
    
    return [
      { id: 'paypal', label: 'PayPal', value: 'paypal' },
      { id: 'venmo', label: 'Venmo', value: 'venmo' },
      { id: 'cheque', label: 'Cheque', value: 'cheque' },
      { id: 'not_set', label: 'Not Set', value: 'not_set' },
    ];
  }

  static async getStatusTypes() {
    return [
      { id: 'Status-open', label: 'Open' },
      { id: 'Status-PartiallyBooked', label: 'Partially Booked' },
      { id: 'Status-FullyBooked', label: 'Fully Booked' },
      { id: 'Status-Collected', label: 'Collected' },
      { id: 'Status-PickedUp', label: 'Picked Up' },
      { id: 'Status-Canceled', label: 'Canceled' }
    ];
  }

  //   "sample_name": "Blood, Urine, Saliva, Hair Follicle",
  // "sample_id": "1, 2, 4, 6",

  static async getSampleTypes() {
    return [
      { id: '1', label: 'Blood', divClass: 'danger', buttonClass: 'text-danger', className: 'el-icon-blood' },
      { id: '2', label: 'Urine', divClass: 'bodyla-fluid', buttonClass: 'text-urine', className: 'el-icon-urine' },//urine
      // { id: '3', label: 'Exhaled Breath', divClass: 'exhaledbreath', buttonClass: 'text-exhaledbreath', className: 'el-icon-exhaledbreath' },
      // { id: '4', label: 'Saliva', divClass: 'bodyla-fluid', buttonClass: 'text-saliva', className: 'el-icon-saliva' },
      // { id: '5', label: 'Buccal Swab', divClass: 'bukkal-swab', buttonClass: 'text-bukkal-swab', className: 'el-icon-buccal-swab' },
      // { id: '6', label: 'Hair Follicle', divClass: 'hair-follicle', buttonClass: 'text-hair-follicle', className: 'el-icon-hair-follicle' },
      // { id: '7', label: 'Skin Tape', divClass: 'text-skin-tap', buttonClass: 'text-skin-tap', className: 'el-icon-skin-tape' },
      { id: '8', label: 'Stool', divClass: 'stool', buttonClass: 'text-stool', className: 'el-icon-stool' },
    ];
  }


  static async getLabLocations() {
    return [
      { id: '1', label: "Downtown Clinic" },
      { id: '2', label: "City Hospital" },
      { id: '3', label: "Health Center A" },
      { id: '4', label: "Eastside Medical" },
      { id: '5', label: "Westside Clinic" }
    ]
  }

  
  static async getDonationStatus() {
    return [
      { id: 3, label: "Completed" },
      { id: 4, label: "No show" }, 
    ]
  }

  
  static async getPaymentStatus() {
    return [
      { id: 1, label: "Pending", value: "pending" },
      { id: 2, label: "Check" , value: "cheque" },
      { id: 3, label: "Check Sent" , value: "check sent" },
      { id: 4, label: "Settled" , value: "settled" },
      { id: 5, label: "Completed" , value: "completed" }
    ]
  }

  static async getAdminListRoleTypes() {
    return [
      { id: 'Superadmin', label: 'Super admin' },
      { id: 'Admin', label: 'Admin' },
    ];
  }
  getAppointments() {

  }
}